import { isNull, sumBy, round } from 'lodash';
import { isUndefined, renderCredit, renderDebit } from './toolkit';
import { formatMoney, formatNumber } from 'accounting';

/**
 * Takes the accouts objects and the journal lines and then
 * extracts the custom rates from the data.
 * 
 * @param {object} journalEntry The journal Entry you want to extract the rate from.
 * @param {object} accounts the accounts in the journal entry.
 */
export function extractCustomRateFromJournalData(journalEntry, accounts) {
    let rates = [];
    // 1. inject currencies to lines.
    journalEntry.lines.map((line) => (line.currency_id = accounts.find((account) => account.id == line.account_id).currency_id));
    journalEntry.lines.forEach((line) => rates.push({ currency_id: line.currency_id, rate: line.rate }));
    return rates;
}

/**
 * Inject customRate to the exchange rates array that was
 * retreived from the servier.
 *
 * @param {array} exchangeRates Array of exchange rates. example { currencyif(["debit", "credit"].includes(type) === false || isNull(type) || isUndefined(type)) {
    //     throw new Error("Incorrect render type.")
    // }, rate: 20 }
 * @param {array} customRates Array of objects of the custom rantes. example { currency_id: 1, rate: 21 }
 * @return {array} The populated exchange rate with custom rate injected on it. example { currency_id: 1, rate: 20, customRate: 20 }
 */
export function populateExchangeRateWithCustomRate(exchangeRates, customRates) {
    // Throw exception if exchange rates where not found!
    if (!exchangeRates) throw new Error("Could not populate custom rate! Exchange Rates are not given.");

    // If no custom rates are supplied, then same rates will be applied to custom rate.
    if (!customRates) exchangeRates.map((each) => (each.customRate = each.rate));
    // otherwise push the supplied custom rate.
    else {
        exchangeRates.map((each) => {
            var custom = customRates.find((customRate) => customRate.currency_id == each.currency_id);
            // If could not find the currency in the custom rate, then use the index rate as custom rate.
            if (isNull(custom) || isUndefined(custom)) each.customRate = each.rate;
            // otherwize set the custom rate.
            else each.customRate = custom.rate;
        });
    }

    return exchangeRates;
}

/**
 * Takes and array and sum in by an attribute in object.
 * It also apply rounding.
 * 
 * @param {Array} array 
 * @param {String} totalBy 
 * @param {Number} round 
 */
export function getTotal(array, totalBy, percision = 2) {
    var total = sumBy(array, (each) => Number((each[totalBy] * 1e12) / 1e12));
    return round(total, percision);
}

/**
 * 
 * @param {"debit" | "credit" | "balance"} type The type of number to be rendered.
 * @param {Number} baseAmount  The Base Amount.
 * @param {Number} baseCurrency The Base Currency
 * @param {Number} amount The Foreign Amount
 * @param {Number} currency The foreign Currency
 * @param {Boolean} foreign if to render a foreing
 * @param {Number} percision The decimal percision
 * 
 * @return {String}
 */
export function renderAmount(type, baseAmount, baseCurrency, amount, currency, foreign = false, percision = 2, currencyVisible = true) {
    
    let renderAmount;
    let renderCurrency;

    renderAmount = foreign ? amount : baseAmount;
    renderCurrency = foreign ? currency : baseCurrency;

    switch(type) {
        case "debit":
            renderAmount = renderDebit(renderAmount);
            break;
        case "credit":
            renderAmount = renderCredit(renderAmount);
            break;
    }

    if(isNull(renderAmount)) return null;

    return currencyVisible
        ? formatMoney(renderAmount, renderCurrency, percision)
        : formatNumber(renderAmount, percision)
}